export default __webpack_public_path__ + "2eb2ca933b275a20a9708e5f80dcea71.png";